import App from "./layout/App";
import Integration from "./layout/integration";
import { AgencyProvider } from "./context/agency";
import AppIframe from "./layout/AppIframe";
import Knowledgebase from "./layout/knowledgebase";
import SupportAppCustomMenuLink from "./layout/SupportAppCustomMenuLink";
import Demo from "./layout/demo";

const useRoutes = () => {
  return [
     {
      key: "support_app",
      route: "/support_app/:companyId/:locationId/:userId/:email/:userName/*",
      component: <SupportAppCustomMenuLink />,
    },
     {
      key: "knowledgebase",
      route: "/knowledgebase/*",
      component: <Knowledgebase />,
    },
    {
      key: "app",
      route: "/:companyId/*",
      component: (
        <AgencyProvider>
          <App />
        </AgencyProvider>
      ),
    },
    {
      key: "app_iframe",
      route: "/app/iframe",
      component: <AppIframe />,
    },
    {
      key: "integrations",
      route: "/integrations/*",
      component: <Integration />,
    },
    {
      key: "demo",
      route: "/demo",
      component: <Demo />,
    },
  ];
};

export default useRoutes;
